import React, { ReactNode } from 'react';
import { StaticContext } from 'react-router';

function getRequestId(staticContext?: StaticContext & { requestId?: string }) {
  if (staticContext?.requestId) return staticContext?.requestId;
  if (__BROWSER__) return window?.chewyConf?.requestId;
}

interface Props {
  staticContext?: StaticContext;
  title: string;
  children: ReactNode;
}

function Error({ staticContext, title, children }: Props) {
  const requestId = getRequestId(staticContext);
  return (
    <div className="kib-text__align-center kib-margin--huge">
      <h1>{title}</h1>
      {children}
      {requestId && (
        <div>
          Request ID: <span>{requestId}</span>
        </div>
      )}
    </div>
  );
}

export default Error;
